module.exports = __webpack_public_path__ + "static/media/icon_smart_search_facial.d79cd351.png";